import { Button, Stack } from "@mui/material";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { t } from "i18next";
import React from "react";
import { useSelector } from "react-redux";
import ServiceInvoicePDF from "../../../components/invoice/Service";

const InvoiceViewer = ({ invoiceData }) => {
  const { currentLanguage } = useSelector((state) => state.translationReducer);

  return (
    <Stack direction="row" my={2} justifyContent={"flex-end"}>
      <PDFDownloadLink
        document={
          <ServiceInvoicePDF
            invoiceData={invoiceData}
            currentLanguage={currentLanguage}
          />
        }
        fileName={`invoice-${invoiceData?.appointmentId}.pdf`}
      >
        {({ blob, url, loading, error }) => (
          <Button variant="contained" disabled={loading} sx={{ minWidth: 120 }}>
            {loading ? t("generating") : t("downloadInvoice")}
          </Button>
        )}
      </PDFDownloadLink>
    </Stack>
  );
};

export default InvoiceViewer;
